var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"CreditTable"},[(_vm.Opt.isTeam)?_c('Operate',{ref:"operate"}):_c('Game',{ref:"game"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }